import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import Table from 'components/commons/Table';

import { ViewContainer, ViewContent } from 'styles/view';

import { IProceduresEmailsViewProps } from './types';

import './i18n';

const ProceduresEmailsView: FunctionComponent<IProceduresEmailsViewProps> = (
  props: IProceduresEmailsViewProps,
) => {
  const { columns, count, data, loading, onAddClick, onTableUpdate, table } = props;

  return (
    <ViewContainer auth data-testid="procedures-emails-view">
      <ViewContent auth>
        <Table
          addButtonText={i18next.t<string>('PROCEDURES_EMAILS_VIEW:SEND_EMAILS')}
          columns={columns}
          count={count}
          data={data}
          loading={loading}
          onAddClick={onAddClick}
          onTableUpdate={onTableUpdate}
          title={i18next.t<string>('PROCEDURES_EMAILS_VIEW:TITLE')}
          table={table}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ProceduresEmailsView;
